var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"tooltip__wrapper",class:{ 'tooltip__wrapper--fixed': _vm.fixed }},[_vm._t("default"),_c('AppTooltipElement',{staticClass:"tooltip__element",class:_vm.placementClassName,attrs:{"text":_vm.text,"placement":_vm.placement,"arrow-position-x":_vm.arrowPositionX}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }